/**
 * sales-page-cart.js v4
 * Shared AJAX cart + cart drawer + upsell modal
 * Used by both Insider's Map and Planning System sales pages
 * v4: iOS scroll fix - body lock + card scroll
 */
window.SalesPageCart = (function() {

  var savedScrollY = 0;

  function getDrawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function(s) { return s.id; }).join(',');
    }
    return 'cart-drawer,cart-icon-bubble';
  }

  function openCartDrawer(btn, origHTML) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      var sections = getDrawerSections();
      fetch('/cart?sections=' + sections)
        .then(function(r) { return r.json(); })
        .then(function(html) {
          drawer.renderContents({ sections: html });
          drawer.classList.remove('is-empty');
          if (!drawer.hasAttribute('open')) {
            drawer.setAttribute('open', '');
          }
          drawer.open();
          if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
        })
        .catch(function() { window.location.href = '/cart'; });
    } else {
      window.location.href = '/cart';
    }
  }

  function addToCart(variantId, btn, skipUpsell) {
    var origHTML = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
    .then(function() {
      var modal = document.getElementById('im-upsell-modal') || document.getElementById('ps-upsell-modal');
      if (modal && !skipUpsell) {
        var upsellVariant = modal.getAttribute('data-upsell-variant');
        if (upsellVariant) {
          return fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var alreadyInCart = cart.items.some(function(item) {
                return String(item.variant_id) === String(upsellVariant);
              });
              if (alreadyInCart) {
                openCartDrawer(btn, origHTML);
              } else {
                btn.disabled = false;
                btn.innerHTML = origHTML;
                showUpsellModal(modal);
              }
            });
        }
      }
      openCartDrawer(btn, origHTML);
    })
    .catch(function() {
      btn.disabled = false;
      btn.innerHTML = origHTML;
      window.location.href = '/cart';
    });
  }

  function lockBodyScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  function showUpsellModal(modal) {
    lockBodyScroll();
    modal.style.display = 'flex';
    requestAnimationFrame(function() {
      modal.classList.add('im-modal-visible');
    });
  }

  function closeUpsellModal(modal) {
    modal.classList.remove('im-modal-visible');
    unlockBodyScroll();
    setTimeout(function() { modal.style.display = 'none'; }, 300);
  }

  function initUpsellModal(prefix) {
    var modal = document.getElementById(prefix + '-upsell-modal');
    if (!modal) return;

    var skipBtns = modal.querySelectorAll('[data-upsell-skip]');
    skipBtns.forEach(function(skipBtn) {
      skipBtn.addEventListener('click', function() {
        closeUpsellModal(modal);
        openCartDrawer(null, null);
      });
    });

    var addBtn = modal.querySelector('[data-upsell-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var vid = modal.getAttribute('data-upsell-variant');
        var origHTML = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
        })
        .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
        .then(function() {
          closeUpsellModal(modal);
          openCartDrawer(null, null);
        })
        .catch(function() {
          addBtn.disabled = false;
          addBtn.innerHTML = origHTML;
          closeUpsellModal(modal);
          window.location.href = '/cart';
        });
      });
    }

    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeUpsellModal(modal);
        openCartDrawer(null, null);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeUpsellModal(modal);
        openCartDrawer(null, null);
      }
    });
  }

  function initForms(prefix) {
    var container = document.getElementById(prefix + '-sales-top');
    if (!container) return;

    var mainForm = document.getElementById(prefix + '-add-form');
    if (mainForm) {
      mainForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var vid = mainForm.querySelector('input[name="id"]').value;
        var btn = mainForm.querySelector('button');
        addToCart(vid, btn, false);
      });
    }

    var crossBtns = container.querySelectorAll('[data-variant-id]');
    crossBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        addToCart(btn.getAttribute('data-variant-id'), btn, true);
      });
    });

    initUpsellModal(prefix);
  }

  return { addToCart: addToCart, initForms: initForms };
})();
